import gql from "graphql-tag";

export default gql`
mutation CheckInInboundCargo($payload: CargoNodeInput!){
    setCargoNode(payload: $payload){
        _id
        name
    }
}
`